// The host's per-wine QR code. A lineup button carries the deep-link path,
// title and subtitle as action params; the code is drawn in the browser
// with the qrcode package (512 px, margin 2 -- the legacy settings) from
// the page's own origin, or the origin the page names (the trade event
// page points at the taste host, where the deep links live), so nothing
// about the URL leaves the device.
import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import QRCode from "qrcode"

const COPIED_FOR_MS = 1500

export default class extends Controller {
  static targets = ["modal", "title", "subtitle", "image", "status", "url", "copy"]
  static values = { origin: String }

  async open(event) {
    const { path, title, subtitle } = event.params
    this.url = `${this.originValue || window.location.origin}${path}`
    this.titleTarget.textContent = title
    this.subtitleTarget.textContent = subtitle
    this.urlTarget.textContent = this.url
    this.imageTarget.hidden = true
    this.statusTarget.textContent = "Generating…"
    this.statusTarget.hidden = false
    this.copyTarget.textContent = "Copy link"
    Modal.getOrCreateInstance(this.modalTarget).show()

    try {
      this.imageTarget.src = await QRCode.toDataURL(this.url, { width: 512, margin: 2 })
      this.imageTarget.hidden = false
      this.statusTarget.hidden = true
    } catch {
      this.statusTarget.textContent = "Couldn't draw the code — copy the link instead."
    }
  }

  // Bootstrap's own events, so the page (and a test) can tell when the
  // modal has finished opening: a close during the fade-in is ignored.
  shown() {
    this.modalTarget.dataset.shown = "true"
    this.copyTarget.focus()
  }

  hidden() {
    delete this.modalTarget.dataset.shown
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.url)
      this.copyTarget.textContent = "Copied!"
      clearTimeout(this.copiedTimer)
      this.copiedTimer = setTimeout(() => { this.copyTarget.textContent = "Copy link" }, COPIED_FOR_MS)
    } catch {
      // Older iOS Safari may refuse without a user-gesture chain; the URL is
      // printed under the code for the host to copy by hand.
    }
  }

  disconnect() {
    clearTimeout(this.copiedTimer)
  }
}
